<div
  [ngClass]="{
    'text-4xl font-semibold': type == 'page-title',
    'text-xl sm:text-2xl font-bold': type == 'headline'
  }"
  [class]="classes"
>
  <ng-content></ng-content>
</div>
